//GENERAL ROUTES

const allLevels = ["company", "branch", "region", "group", "dealer"];

export const dashboardRoute = {
  route: "Dashboard",
  path: "/dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["dashboard"],
  view: [
    "station",
    "staffManangement",
    "stationLease",
    "maintenance",
    "remis",
    "drystock",
  ],
  levels: allLevels,
};

const expenseMgt = {
  route: "Expense Management",
  path: "/Expense-management",
  routeIcon: "money-4.svg",
  activeRouteIcon: "money-4-green.svg",
  children: [],
  name: ["Expense Management", "Expense Details"],
  view: ["station"],
  levels: ["company", "branch"],
  roles: ["ViewExpense", "ManageExpense"],
};
const bank = {
  route: "Bank",
  path: "/bank-accounts",
  routeIcon: "bank.svg",
  activeRouteIcon: "bank-green.svg",
  children: [
    {
      route: "Bank accounts",
      path: "/bank-accounts",
    },
    {
      route: "Bank account requests",
      path: "/bank-account-requests",
    },
  ],
  view: ["station"],
  name: ["bank-accounts"],
  levels: ["company", "branch"],
  roles: ["manageBankAccounts"],
};

const rentalRecords = {
  route: "Rental Mgt",
  path: "",
  routeIcon: "building-office-2.svg",
  activeRouteIcon: "active-building-office-2.svg",
  children: [
    {
      route: "Properties",
      path: "/properties",
      roles: ["ManageRent", "RentProperties"],
    },
    {
      route: "Rent records",
      path: "/rent-records",
      roles: ["ManageRent", "RentRecords"],
    },
    {
      route: "Occupants",
      path: "/occupants",
      roles: ["ManageRent", "Occupants"],
    },
  ],
  name: [
    "rent-records",
    "properties",
    "property-details",
    "Occupants",
    "occupant-details",
  ],
  view: ["stationLease"],
  levels: allLevels,
  // roles: ["ViewRent", "ManageRent"],
  roles: ["ManageRent", "RentProperties", "RentRecords", "Occupants"],
};

const maintenance = {
  route: "Maintenance ",
  path: "/maintenance",
  routeIcon: "wrench-screwdriver.svg",
  activeRouteIcon: "wrench-screwdriver-active.svg",
  children: [],
  name: ["maintenance"],
  view: ["maintenance"],
  levels: allLevels,
  roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
};
const support = {
  route: "Support",
  path: "/support",
  routeIcon: "message-question.svg",
  activeRouteIcon: "message-question.svg",
  children: [],
  name: ["support"],
  levels: allLevels,
  view: ["station"],
};
const userMgt = {
  route: "User management",
  path: "/user-management",
  routeIcon: "user-group.svg",
  activeRouteIcon: "inactive-user-group.svg",
  children: [],
  name: ["user-management", "single-user"],
  view: ["station"],
  levels: allLevels,
  roles: ["ManageUsers"],
};
const manageApproval = {
  route: "Manage approval",
  path: "/manage-approval",
  routeIcon: "grey-check-badge.svg",
  activeRouteIcon: "active-check-badge.svg",
  children: [],
  name: ["manage-approval"],
  view: ["station"],
  levels: allLevels,
  roles: ["manageApproval"],
};
export const generalRoutes = [
  manageApproval,
  bank,
  userMgt,
  expenseMgt,
  rentalRecords,
  maintenance,
  support,
];
